import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  openActivityPanel,
  closeActivityPanel,
  toggleActivityMinimize,
  focusActivityPanel,
  closeAllActivityPanels,
  ActivityPanelMode,
} from "../store/slices/activityPanelSlice";

export const useActivityPanel = () => {
  const dispatch = useAppDispatch();
  const panels = useAppSelector((state) => state.activityPanel.panels);
  const focusedActivityId = useAppSelector((state) => state.activityPanel.focusedActivityId);

  const openActivity = useCallback(
    (activityId: number, mode?: ActivityPanelMode) =>
      dispatch(openActivityPanel(mode ? { activityId, mode } : activityId)),
    [dispatch]
  );

  const closeActivity = useCallback(
    (activityId: number) => dispatch(closeActivityPanel(activityId)),
    [dispatch]
  );

  const toggleActivity = useCallback(
    (activityId: number) => dispatch(toggleActivityMinimize(activityId)),
    [dispatch]
  );

  const focusActivity = useCallback(
    (activityId: number) => dispatch(focusActivityPanel(activityId)),
    [dispatch]
  );

  const closeAllActivities = useCallback(
    () => dispatch(closeAllActivityPanels()),
    [dispatch]
  );

  return {
    panels,
    focusedActivityId,
    openActivity,
    closeActivity,
    toggleActivity,
    focusActivity,
    closeAllActivities,
  };
};
